import {
  ShieldCheck,
  Wifi,
  Sparkles,
  Droplets,
  UtensilsCrossed,
  Dumbbell,
  Bath,
  Waves,
  Bus,
  Home,
  Users,
  HeartHandshake,
} from "lucide-react";

export const SITE = {
  name: "Ada",
  fullName: "Samsun Ada Kız Öğrenci Yurdu",
  phone: "0505 799 00 55",
  phoneTel: "+905057990055",
  phone2: "0362 799 00 55",
  phone2Tel: "+903627990055",
  whatsapp: "905057990055",
  whatsappMessage: "Merhaba, Samsun Ada Kız Öğrenci Yurdu hakkında bilgi almak istiyorum.",
  email: "info@samsunadakizogrenciyurdu.com",
  address: "Körfez Mah. Atatürk Bulvarı No:73, 55270 Atakum / Samsun",
  instagram: "https://instagram.com",
  mapQuery: "Körfez, Atatürk Blv. No:73, Atakum/Samsun",
};

export const waLink = (message) =>
  `https://wa.me/${SITE.whatsapp}?text=${encodeURIComponent(message || SITE.whatsappMessage)}`;

export const NAV_LINKS = [
  { to: "/", label: "Ana Sayfa", id: "anasayfa" },
  { to: "/hakkimizda", label: "Hakkımızda", id: "hakkimizda" },
  { to: "/odalar", label: "Odalar", id: "odalar" },
  { to: "/hizmetler", label: "Hizmetler", id: "hizmetler" },
  { to: "/galeri", label: "Galeri", id: "galeri" },
  { to: "/videolar", label: "Videolar", id: "videolar" },
  { to: "/konum", label: "Konum", id: "konum" },
  { to: "/iletisim", label: "İletişim", id: "iletisim" },
];

const u = (id) => `https://images.unsplash.com/${id}?q=85&w=1600&auto=format&fit=crop`;

export const HERO_SLIDES = [
  { src: u("photo-1616594039964-ae9021a400a0"), alt: "Modern ve aydınlık öğrenci odası" },
  { src: u("photo-1507525428034-b723cf961d3e"), alt: "Atakum sahili — yurda yalnızca 2 dakika" },
  { src: u("photo-1585418694458-dc80a5c20294"), alt: "Ortak yaşam alanı" },
];

export const ROOMS = [
  {
    slug: "tek-kisilik",
    name: "Tek Kişilik Oda",
    capacity: "1 Kişi",
    size: "Deniz Manzaralı",
    desc: "Tamamen size özel bir yaşam alanı. Balkonunuzdan denizi izleyin; ayrı giyinme ve çalışma odanızda gününüzü verimli planlayın.",
    features: ["Özel Banyo & WC", "Mini Buzdolabı & TV", "Ayrı Giyinme Odası", "Çalışma Odası"],
    image: u("photo-1595526114035-0d45ed16cfbf"),
  },
  {
    slug: "iki-kisilik",
    name: "İki Kişilik Oda",
    capacity: "2 Kişi",
    size: "Balkonlu",
    desc: "Arkadaşlık ve mahremiyetin mükemmel dengesi. Balkonlu, deniz manzaralı seçeneğiyle hem sosyal hem huzurlu bir paylaşım alanı.",
    features: ["Özel Banyo & WC", "Mini Buzdolabı & TV", "Giyinme Odası", "Balkon"],
    image: u("photo-1567767292278-a4f21aa2d36e"),
  },
  {
    slug: "uc-kisilik",
    name: "Üç Kişilik Oda",
    capacity: "3 Kişi",
    size: "Balkonlu",
    desc: "Sosyal ve ekonomik bir seçenek arayanlar için; her öğrenciye özel çalışma köşesi ve geniş ortak yaşam alanıyla.",
    features: ["Özel Banyo & WC", "Mini Buzdolabı & TV", "Kişisel Çalışma Köşesi", "Balkon"],
    image: u("photo-1555854877-bab0e564b8d5"),
  },
  {
    slug: "dort-kisilik",
    name: "Dört Kişilik Oda",
    capacity: "4 Kişi",
    size: "Geniş & Ferah",
    desc: "Kalabalık arkadaş grupları için ideal; geniş planı, ayrı giyinme odası ve deniz manzaralı balkonuyla eviniz gibi.",
    features: ["Özel Banyo & WC", "Mini Buzdolabı & TV", "Ayrı Giyinme Odası", "Deniz Manzarası"],
    image: u("photo-1505693416388-ac5ce068fe85"),
  },
];

export const SERVICES = [
  { icon: ShieldCheck, title: "7/24 Güvenlik", desc: "Güvenlik ekibi ve düzenli denetimlerle günün her saati kesintisiz huzur." },
  { icon: Wifi, title: "Sınırsız İnternet", desc: "Kesintisiz yüksek hızlı internet; dersler ve yayınlar için güçlü altyapı." },
  { icon: Droplets, title: "24 Saat Sıcak Su", desc: "Günün her saati, hiç kesintisiz sıcak su konforu." },
  { icon: UtensilsCrossed, title: "Açık Büfe Kahvaltı & Akşam Yemeği", desc: "Profesyonel aşçımızın hazırladığı açık büfe kahvaltı ve dört çeşit akşam yemeği." },
  { icon: Dumbbell, title: "Fitness Salonu", desc: "Ders aralarında enerjinizi atacağınız, modern ekipmanlı fitness salonu." },
  { icon: Bath, title: "Her Odada Özel Banyo", desc: "Tüm odalarda size özel banyo & WC; sabah sırası beklemek yok." },
  { icon: Waves, title: "Denize Sıfır Konum", desc: "Sahilin en güzel yerinde; denize yalnızca 2 dakika yürüme mesafesi." },
  { icon: Bus, title: "Toplu Taşıma Kolaylığı", desc: "Ana yol üzerindeki konumumuzla okula giden toplu taşıma duraklarına birkaç adım." },
];

export const VALUES = [
  { icon: ShieldCheck, title: "Güvenlik Önceliğimiz", desc: "Ailenizin huzuru, sizin güvenliğiniz: her katmanda denetlenen bir yaşam." },
  { icon: Sparkles, title: "Tertemiz Alanlar", desc: "Hijyen standartlarımız düzenli olarak denetlenir ve titizlikle uygulanır." },
  { icon: Waves, title: "Denize Sıfır Yaşam", desc: "Sahile 2 dakika; gün batımı yürüyüşleri ders molalarınızın parçası olur." },
  { icon: Home, title: "Sıcak Bir Yuva", desc: "Ada'da her detay, evinizde hissettirmek için özenle tasarlandı." },
  { icon: Users, title: "Güçlü Topluluk", desc: "Farklı şehirlerden gelen yüzlerce öğrencinin ikinci ailesi." },
  { icon: HeartHandshake, title: "Aile Gibi İlgi", desc: "Yurt ekibimiz her öğrenciyi ismiyle tanır; ihtiyaç anında yanındadır." },
];

export const STATS = [
  { value: "2 dk", label: "Sahile Yürüme Mesafesi" },
  { value: "7/24", label: "Güvenlik & Sıcak Su" },
  { value: "1-4", label: "Kişilik Oda Seçeneği" },
  { value: "%98", label: "Öğrenci Memnuniyeti" },
];

export const MANIFESTO = [
  {
    no: "01",
    title: "Güven",
    text: "Güvenlik ekibinden düzenli denetimlere; güvenlik bizde bir özellik değil, her gün yeniden verilen bir sözdür.",
  },
  {
    no: "02",
    title: "Konfor",
    text: "Deniz manzaralı balkonlu odalar, her odada özel banyo & WC ve ayrı giyinme–çalışma odasıyla gerçek bir dinlenme deneyimi tasarladık.",
  },
  {
    no: "03",
    title: "Topluluk",
    text: "Sahil yürüyüşlerinden teras sohbetlerine; Ada'da kurulan arkadaşlıklar en az diplomalar kadar kalıcıdır.",
  },
];

export const MARQUEE_ITEMS = [
  "Denize Sıfır Konum",
  "Sahile 2 Dakika",
  "Açık Büfe Kahvaltı",
  "Fitness Salonu",
  "Güvenli Yaşam",
  "Sıcak Bir Yuva",
];

export const GALLERY = [
  { src: u("photo-1616594039964-ae9021a400a0"), alt: "Öğrenci odası", ratio: "aspect-[3/4]" },
  { src: u("photo-1585418694458-dc80a5c20294"), alt: "Ortak lounge alanı", ratio: "aspect-[4/3]" },
  { src: u("photo-1590381105924-c72589b9ef3f"), alt: "Ahşap detaylı dinlenme köşesi", ratio: "aspect-[3/4]" },
  { src: u("photo-1522708323590-d24dbb6b0267"), alt: "Ferah yaşam alanı", ratio: "aspect-square" },
  { src: u("photo-1505693416388-ac5ce068fe85"), alt: "Suit oda yatak detayı", ratio: "aspect-[4/5]" },
  { src: u("photo-1560448204-e02f11c3d0e2"), alt: "Modern oturma alanı", ratio: "aspect-[4/3]" },
  { src: u("photo-1540518614846-7eded433c457"), alt: "Konforlu oda atmosferi", ratio: "aspect-[3/4]" },
  { src: "https://images.pexels.com/photos/7683743/pexels-photo-7683743.jpeg?auto=compress&cs=tinysrgb&w=1200", alt: "Birlikte çalışan öğrenciler", ratio: "aspect-[4/3]" },
  { src: u("photo-1598928506311-c55ded91a20c"), alt: "Sosyal alan detayı", ratio: "aspect-square" },
  { src: "https://images.pexels.com/photos/9489775/pexels-photo-9489775.jpeg?auto=compress&cs=tinysrgb&w=1200", alt: "Etüt alanında kitap okuyan öğrenciler", ratio: "aspect-[3/4]" },
  { src: u("photo-1521017432531-fbd92d768814"), alt: "Yurt kafe alanı", ratio: "aspect-[4/3]" },
  { src: u("photo-1586023492125-27b2c045efd7"), alt: "Dinlenme köşesi", ratio: "aspect-[3/4]" },
  { src: u("photo-1507525428034-b723cf961d3e"), alt: "Atakum sahili — yurda 2 dakika", ratio: "aspect-[4/3]" },
  { src: u("photo-1519046904884-53103b34b206"), alt: "Gün batımında sahil", ratio: "aspect-[3/4]" },
];

export const VIDEOS = [
  {
    id: "tanitim",
    title: "Ada'yı Keşfedin",
    subtitle: "Genel Tanıtım Filmi",
    duration: "02:14",
    poster: u("photo-1585418694458-dc80a5c20294"),
    src: "https://videos.pexels.com/video-files/3773486/3773486-hd_1920_1080_30fps.mp4",
  },
  {
    id: "oda-turu",
    title: "Oda Turu",
    subtitle: "Odalarımız",
    duration: "01:38",
    poster: u("photo-1616594039964-ae9021a400a0"),
    src: "https://videos.pexels.com/video-files/3209828/3209828-hd_1920_1080_25fps.mp4",
  },
  {
    id: "sosyal-alanlar",
    title: "Sosyal Yaşam",
    subtitle: "Ortak Alanlar & Etkinlikler",
    duration: "01:52",
    poster: "https://images.pexels.com/photos/7683743/pexels-photo-7683743.jpeg?auto=compress&cs=tinysrgb&w=1200",
    src: "https://videos.pexels.com/video-files/5752729/5752729-hd_1920_1080_30fps.mp4",
  },
];

export const ABOUT_IMAGES = {
  main: u("photo-1590381105924-c72589b9ef3f"),
  secondary: u("photo-1519046904884-53103b34b206"),
  students: "https://images.pexels.com/photos/7683743/pexels-photo-7683743.jpeg?auto=compress&cs=tinysrgb&w=1200",
};
